// Writes your routes here

// information-application-management
export const regOganizationListApi = 'applicationManagement/registered-organization/list'
export const regOrganizationStoreApi = 'applicationManagement/registered-organization/store'
export const regOrganizationUpdateApi = 'applicationManagement/registered-organization/update'
export const regOrganizationToggleStatusApi = 'applicationManagement/registered-organization/toggle-status'

// Circular Publication
export const circularpublication = '/circular/publication/'
export const circularpublicationListApi = circularpublication + 'list'
export const circularPublicationStoreApi = circularpublication + 'store'
export const circularpublicationUpdateApi = circularpublication + 'update'
export const circularpublicationToggleStatusApi = circularpublication + 'toggle-status'

// Application
export const applicationList = 'applicationManagement/application/list'
export const pendingApplicationList = 'applicationManagement/application/pending-list'
export const applicationSortList = 'applicationManagement/application/sort-list'
export const applicationSortStore = 'applicationManagement/application/sort-store'
export const applicationForwardList = 'applicationManagement/application/forward-list'
export const applicationFinalList = 'applicationManagement/application/final-list'
export const applicationForwardStore = 'applicationManagement/application/forward-store'
export const applicationFinalStore = 'applicationManagement/application/final-store'
export const assignDesignationList = 'common/assign-designation-list'
export const multiApplicationApproveRemove = 'applicationManagement/application/approve-remove-multi'
export const applicationApproveRemove = 'applicationManagement/application/approve-remove'
export const applicationApproveList = 'applicationManagement/application/approve-list'
export const applicationApproveStore = 'applicationManagement/application/approve-store'
export const applicationScApproveList = 'applicationManagement/application/schedule-approve-list'
export const applicationSortRemove = 'applicationManagement/application/sort-remove'
export const applicationForwardRemove = 'applicationManagement/application/forward-remove'
export const applicationFinalRemove = 'applicationManagement/application/final-remove'
export const applicationFinalMultiRemove = 'applicationManagement/application/final-multi-remove'
export const applicationStore = 'applicationManagement/application/store'
export const applicationCheck = 'applicationManagement/application/check'
export const applicationUpdate = 'applicationManagement/application/update'
export const applicationToggle = 'applicationManagement/application/toggle-status'
export const BatchEnrollmentStore = 'applicationManagement/application/enrollment-store'
export const BatchEnrollmentList = 'applicationManagement/application/enrollment-list'

// batch-schedule
export const batchScheduleListApi = 'applicationManagement/batch-schedule/list'
export const batchScheduleStoreApi = 'applicationManagement/batch-schedule/store'
export const batchScheduleUpdateApi = 'applicationManagement/batch-schedule/update'
export const batchScheduleToggleApi = 'applicationManagement/batch-schedule/toggle-status'

// Complain
export const ComplainListApi = 'complain/list'
export const ComplainReqStoreApi = 'complain/store2'
export const ComplainSolveApi = 'complain/solve'

// Doc request
export const DocReqListApi = 'doc-request/list'
export const DocReqStoreApi = 'doc-request/store2'
export const DocReqSolveApi = 'doc-request/solve'

// Nothi api
export const nothi = 'nothi/'
export const pendingNothiCircualrList = nothi + 'circualr-sent-nothi'
export const reSentNothiCircualrList = nothi + 'circualr-re-sent-nothi'
